export const getInvoiceNos = (): string[] => {
    return [
        'INV-2023123456',
        'INV-2023123457',
        'INV-2023123458',
        'INV-2023123459',
        'INV-2023123460',
        'INV-2023123461',
        'INV-2023123462',
        'INV-2023123463',
        'INV-2023123464',
    ]
}
